<router-outlet></router-outlet>

@if (changeDetectionTrackingOpen) {
  <div class="change-detection-info">
    <dt-change-detection-info></dt-change-detection-info>
  </div>
}
